<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <h4 class="text-2xl font-bold">Surcharge</h4>
            <div class="flex align-center">
                <vs-switch v-model="surcharge_active" class="my-6" @click.stop="updateSurcharge"/>
                <span class="pl-5">An additional charge for credit payment</span>
            </div>
            <div v-if="surcharge_active">
                <p class="mb-4" style="color: #A0A0A0">Charge percentage</p>
                <vs-input maxlength="3" min="0" :max="max" v-model="charge_value" :key="charge_key" class="w-6/12" v-on:keypress="isNumber($event)"></vs-input>
                <div class="flex-center pt-6">
                    <vs-button style="min-width: 150px;">Save</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
export default {
    name: 'surcharge-setting',
    data() {
        return {
            surcharge_active: false,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: '',
            max: 100,
            charge_value: 0,
            charge_key: 0
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 0) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Surcharge Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) || parseInt(this.charge_value + '' + evt.key) > this.max) {
                evt.preventDefault();
            } else {
                if(this.charge_value == 0) {
                    this.charge_value = '';
                }
                return true;
            }
        },
        updateSurcharge() {
            
        }
        // updatePaxStandalone() {
        //     const obj = {
        //         key: 'config.pos.pax_standalone_active',
        //         value: !this.pax_standalone_active ? 1 : 0
        //     }
        //     this.action_type = 'Update';
        //     this.openLoadingInDiv();
        //     this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
        //         this.closeLoading();
        //         this.$vs.notify({
        //         title:'Notification',
        //         text:'Update Standalone PAX Mode Success',
        //         color:'success',
        //         position:'top-right'})
        //     });
        // }
    },
    // created() {
    //     const obj = {
    //         key: 'config.pos.pax_standalone_active'
    //     }

    //     this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
    //         this.loaded_data_num++;
    //         let pax_standalone_active = this.$store.getters["appSetting/keyStorage"];
    //         this.pax_standalone_active = pax_standalone_active.value == 1 ? true : false;
    //     }).catch(() => {
    //         const obj = {
    //             key: 'config.pos.pax_standalone_active',
    //             value: 0
    //         }
    //         this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
    //             this.loaded_data_num++;
    //         })
    //     })
    // }
}
</script>

